import React, { useState, useRef } from 'react';

const IFramePrinter = ({ url, fileType = 'application/pdf' }) => {
    const frameRef = useRef(null);

    function gen4() {
        return Math.random().toString(16).slice(-4);
    }

    function simpleUniqueId(prefix) {
        return (prefix || '').concat(
            [gen4(), gen4(), gen4(), gen4(), gen4(), gen4(), gen4(), gen4()].join('')
        );
    }

    React.useEffect(() => {
        blobUrlToPrint(url, fileType);
    }, [url]);

    const [iFrameSrc, setIFrameSrc] = useState('');
    const [printRequested, setPrintRequested] = useState(false);

    function printFrame(e) {
        if (printRequested) {
            setPrintRequested(false);
            frameRef.current.contentWindow.print();
        }
    }

    const blobUrlToPrint = (blobUrl, fileType = 'application/pdf') => {
        if (!blobUrl || blobUrl === '') {
            return;
        }
        setPrintRequested(true);
        var sasURL = blobUrl;
        fetch(sasURL)
            .then((resp) => resp.blob())
            .then((blob) => {
                var base64String = '';
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function () {
                    if (reader.result != null) {
                        base64String = reader.result.toString().replace(/^data:.+;base64,/, '');
                    }
                    let byteCharacters = atob(base64String);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], { type: 'application/pdf;base64' });

                    setIFrameSrc(URL.createObjectURL(file));
                };
            })
            .catch((error) => {
                alert('There was an error attempting to print, please try again later');
            });
    };

    return (
        <>
            <iframe
                id={simpleUniqueId('frame-')}
                name={simpleUniqueId('frame-')}
                src={iFrameSrc}
                style={{ display: 'none' }}
                frameBorder='0'
                scrolling='no'
                allowFullScreen={true}
                onLoad={printFrame}
                ref={frameRef}
            />
        </>
    );
};

export default IFramePrinter;

/*

const blobUrlToPrint = (blobUrl: string, fileType: string = "application/pdf") => {
        var sasURL = blobUrl;
        fetch(sasURL)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
    
                var base64String = "";
 
                var reader = new FileReader();
                reader.readAsDataURL(blob)
                reader.onloadend = function () {
    
    
    
                    if (reader.result != null) {
                        base64String = reader.result.toString().replace(/^data:.+;base64,/, '');
    
                    }
    
                    let byteCharacters = atob(base64String);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], { type: 'application/pdf;base64' });
                
                    setIFrameSrc(URL.createObjectURL(file));                  
                    
                }
        
            })
            .catch(() => alert('There was an error attempting to print, please try again later'));
        
    }
*/
